<template>
  <tr class="is-centered">
    <td>{{ transaction.transactionId }}</td>
    <td>{{ transaction.email }}</td>
    <td>{{ dateToUTC(transaction.timestamp) }}</td>
    <td>{{ formatAmount(transaction.settledAmount, 'JPY') }}</td>
    <td>{{ transaction.firstName }}</td>
    <td>{{ transaction.surname }}</td>
    <td>{{ transaction.bankName }}</td>
    <td>{{ transaction.bankCode }}</td>
    <td>{{ transaction.branchCode }}</td>
    <td>{{ transaction.accountNumber }}</td>
    <td>{{ transaction.companyName }}</td>
    <td>{{ transaction.nonce }}</td>
    <td>{{ transaction.merchantId }}</td>
    <td v-if="transaction.status === 'CREATED' || transaction.status === 'INITIALIZED'" />
    <td v-else>
      {{ dateToUTC(transaction.transactionRequestDate) }}
    </td>
    <td>
      <StatusIcon
        :status="transaction.status"
      />
    </td>
    <td v-if="shouldDisplayCreation">
      <span
        class="p-1"
        :class="classNameForCreation(transaction.creation)"
      >
        {{ transaction.creation }}
      </span>
    </td>
    <td>{{ formatAmount(transaction.processingFee, transaction.currency) }}</td>
    <td>{{ formatAmount(transaction.authorizedAmount, transaction.currency) }}</td>
    <td v-if="shouldDisplaySourceBankName">
      {{ transaction.sourceBankName }}
    </td>
    <td>
      <button
        v-if="transaction.creation !== 'MANUAL'"
        class="is-clickable button is-small is-primary modal-button"
        @click="edit(transaction)"
      >
        <i class="fas fa-lg fa-pencil-alt" />
      </button>
    </td>
    <td>
      <ReceiveTransaction
        v-if="transaction.status === 'CREATED'"
        :transaction-id="transaction.transactionId"
      />
    </td>
    <td v-if="shouldDisplayReceivedBy">
      {{ transaction.receivedBy }}
    </td>
  </tr>
</template>

<script>

import ReceiveTransaction from './ReceiveTransaction.vue';
import StatusIcon from './StatusIcon.vue';
import initializeFlagsmith from '../flagsmith';

export default {
    components: {
        StatusIcon,
        ReceiveTransaction,
    },

    props: {
        transaction: {
            type: Object,
            required: true,
        },
        edit: {
            type: Function,
            required: true,
        },
    },

    async setup() {
        const formatAmount = (amount, curr) => {
            const locale = navigator.language;
            return new Intl.NumberFormat(locale, { style: 'currency', currency: curr }).format(amount / 100);
        };

        const dateToUTC = (date) => date.toUTCString();

        const classNameForCreation = (value) => {
            if (value === 'MODIFIED') {
                return 'has-background-warning';
            }

            if (value === 'MANUAL') {
                return 'has-background-danger has-text-white';
            }

            if (value === 'SYSTEM') {
                return 'has-text-danger-dark';
            }
            return 'has-text-black-bis';
        };

        const flagsmith = await initializeFlagsmith();
        const shouldDisplaySourceBankName = flagsmith.hasFeature('btb_source_bank');
        const shouldDisplayReceivedBy = flagsmith.hasFeature('btb_admin_received_by_column');
        const shouldDisplayCreation = flagsmith.hasFeature('creation_status_btb');

        return {
            formatAmount,
            dateToUTC,
            shouldDisplaySourceBankName,
            shouldDisplayReceivedBy,
            classNameForCreation,
            shouldDisplayCreation,
        };
    },
};
</script>

<style>
.is-not-wrapped td {
  white-space: nowrap;
}
</style>
